import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@shared-utils/ui";

const badgeVariants = cva(
  "relative inline-flex h-5 items-center whitespace-nowrap rounded-md border px-1.5 text-xs text-foreground shadow-sm transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2 dark:text-foreground",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-foreground shadow-sm",
        yellow: "border-ter-yellow-400 bg-ter-yellow-200",
        red: "border-tl-red-400 bg-tl-red-200",
        green: "border-tl-green-400 bg-ter-green-200",
        brightGreen: "border-foreground/10 bg-sec-bright-green text-foreground",
        blue: "border-ter-blue-400 bg-ter-blue-200 text-foreground",

        secondary: "border-ter-gray-200 bg-ter-gray-50 text-ter-gray-500",
        white: "border-ter-gray-200 bg-background text-ter-gray-500",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/80",
        outline: "text-foreground",
      },
      size: {
        lg: "size-md px-1 rounded-sm -mx-0.5 h-7.5 px-2",
        md: "size-xxs px-1 rounded-sm -mx-0.5 h-4.5",
        sm: "size-xxs px-1 rounded-sm -mx-0.5 h-4.5",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return (
    <div
      className={cn(badgeVariants({ variant, size }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
